import React, { useEffect, useState } from 'react';
import Helmet from 'react-helmet';
import styled from '@emotion/styled';
import { animated, config, useTransition } from 'react-spring';
import { useLocation } from 'react-router';

import RegistrationContainer from './components/containers/RegistrationContainer';
import optimizeImage from '../../shared/utils/imageOptimizer';

const MainContent = styled('main')`
  align-items: flex-start;
  background: ${(props) => props.theme.colors.darkBlue};
  display: flex;
  height: 100vh;
  justify-content: center;
  min-height: 100vh;
  overflow-y: auto;
  padding-top: 40px;
  padding-bottom: 40px;
  position: relative;
  width: 100%;

  a {
    align-self: center;
  }

  .registration-image-container {
    background-image: ${(props) => props.theme.colors.gradientOverlay}, url('https://s3.amazonaws.com/teambuildr-${process.env.ENVIRONMENT !== 'PRODUCTION' ? 'staging' : 'production'}-assets/backgrounds/image_login_1.jpg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    bottom: 0;
    left: 0;
    min-height: 100%;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 0;
  }

  @media screen and (max-width: 768px) {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  @media screen and (max-width: 425px) {
    padding-top: 0;
    padding-bottom: 0;
  }
`;

const slides = Array(12).fill(0);

slides.forEach((slide, index, slidesArray) => {
  const slidesArrayObject = slidesArray;

  slidesArrayObject[index] = {
    id: index,
    url: optimizeImage(
      `https://s3.amazonaws.com/teambuildr-${process.env.ENVIRONMENT !== 'PRODUCTION' ? 'staging' : 'production'}-assets/backgrounds/image_login_${index + 1}.jpg`,
      {
        resize: {
          width: 1500, height: 1500, fit: 'inside',
        },
      },
    ),
  };
});

const Registration = () => {
  const [imageIndex, setImageIndex] = useState(0);

  const imageTransition = useTransition(slides[imageIndex], (item) => item.id, {
    config: config.molasses,
    enter: { opacity: 1 },
    from: { opacity: 0 },
    leave: { opacity: 0 },
  });

  useEffect(() => (
    setInterval(() => (
      setImageIndex((state) => (state + 1) % slides.length)
    ), 6000)
  ), []);

  const { pathname } = useLocation();
  const helmetTitle = pathname.includes('easy-join') ? 'Easy Join | TeamBuildr' : 'Registration | TeamBuildr';

  return (
    <MainContent>
      <Helmet>
        <title>{helmetTitle}</title>
      </Helmet>
      <RegistrationContainer />
      {imageTransition.map(({ item, props, key }) => (
        <animated.div
          className='registration-image-container'
          key={key}
          style={{ ...props, backgroundImage: `linear-gradient(-20deg, rgba(252, 96, 118, 0.5) 0%, rgba(255, 154, 68, .5) 100%), url(${item.url})` }}
        />
      ))}
    </MainContent>
  );
};

export default Registration;
